import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router} from "@angular/router";
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";
import {ProfileUserComponent} from "../profile-user.component";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {CustomsValidationDirective} from "../../../../_directives/customs-validation.directive";
import {UserService} from "../../../../_services/user.service";
import {ConfirmComponent} from "../../../../_common/confirm/confirm.component";
import {AuthenticationService} from "../../../../_services/authentication.service";

@Component({
    selector: 'app-change-profile',
    templateUrl: './change-profile.component.html',
    styleUrls: ['../change-profile.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class ChangeProfileComponent extends DialogComponent<ProfileUserComponent, boolean> implements OnInit {

    loading = false;
    changePassword: FormGroup;
    msgErrPassConfirm: any;
    missOldPassword: any = null;

    constructor(dialogService: DialogService,
                private router: Router,
                private f: FormBuilder,
                private userService: UserService,
                private authenticationService: AuthenticationService) {
        super(dialogService);
    }

    ngOnInit() {
        this.changePassword = this.f.group({
            oldPwd: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.minLength(6)]),
            passConfirm: new FormControl('', [Validators.required])
        }, {
            validator: CustomsValidationDirective.MatchPassword
        });
    }

    editChangePassword() {
        let self = this;
        if (this.changePassword.valid) {
            this.loading = true;
            this.userService.changePasswordProfile(this.changePassword.value).subscribe(res => {
                if (res.hasOwnProperty('type') && res.type == '_SUCCESS_' && res.hasOwnProperty('status') && res.status == true) {
                    // Change password success
                    self.close();
                    self.confirmLoginAfterChangePassword(resConfirm => {
                        // logout and redirect login
                        if (resConfirm == true) {
                            self.authenticationService.logout();
                            self.router.navigate(['/login']);
                        }
                    });
                } else {
                    if (res.hasOwnProperty('type') && res.type == '_FAIL_') {
                        self.missOldPassword = res.hasOwnProperty('message') ? res.message : null;
                    } else if (res.hasOwnProperty('type') && res.type == '_VALIDATE_') {
                        self.msgErrPassConfirm = (res.hasOwnProperty('error') && res.error.hasOwnProperty('passConfirm')) ? res.error.passConfirm[0] : null;
                    }
                }
            }, error => {
                self.close();
                console.log(error);
                this.result = true;
            }, () => {
                this.result = true;
                this.loading = false;
            })
        } else {
            CustomsValidationDirective.validateAllFormFields(self.changePassword);
        }
    }

    changeKeyUp() {
        this.missOldPassword = null;
        this.msgErrPassConfirm = null;
    }

    confirmLoginAfterChangePassword(callback) {
        this.result = true;
        this.dialogService.addDialog(ConfirmComponent, {
            title: '最終確認',
            message: 'パスワードを更新してよろしいでしょうか？'
        }).subscribe((isConfirmed) => {
            callback(isConfirmed);
        });
    }

    isFieldValid(field: string) {
        return !this.changePassword.get(field).valid && this.changePassword.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
            'has-feedback': this.isFieldValid(field)
        };
    }

    noWhitespaceValidator(control: FormControl) {
        return (control.value || '').indexOf(' ') >= 0 ? { 'whitespace': true } : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/profile-user/change-profile/change-profile.component.ts